"use strict";

module.exports = {
  UP: "<",
  // one level up
  SAME: ",",
  // same level
  DOWN: ">",
  // one level down
  RESET: "|",
  // reset level index and start new
  WILDCARD: "*",
  // as defined by publicsuffix.org
  EXCEPTION: "!" // as defined by publicsuffix.org

};